export default __webpack_public_path__ + "static/media/1.cb3a033c.jpg";